var _path, _path2, _circle, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 130,
    viewBox: "0 0 160 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158.589 61.9631C162.731 50.0301 135.551 33.7833 79.051 24.4637",
    stroke: "#A9DEFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1292 102.496C68.301 114.334 124.768 111.81 129.77 98.5133C134.736 85.3129 96.4867 69.1656 66.6683 59.5787C30.7503 48.03 3.5 42 1 50.5871",
    stroke: "#A9DEFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 50,
    r: 50,
    fill: "#0088FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M106.679 101.484C104.917 99.7222 103.752 97.4515 103.349 94.9922L101.709 84.9821L111.719 86.6223C114.178 87.0253 116.449 88.1899 118.211 89.9521L140.502 112.243C143.686 115.427 143.686 120.59 140.502 123.775C137.317 126.959 132.154 126.959 128.969 123.775L106.679 101.484Z",
    fill: "#0088FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00013 51C-0.5 61.5 42.235 67.9205 66.9184 70.9471C91.6018 73.9737 151.373 78.0491 158.583 61.9639",
    stroke: "#A9DEFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not_found.4b17c480ad64032a1f10f965ae72e136.svg";
export { ForwardRef as ReactComponent };